import axios from 'axios';

const API_URL =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_API_URL_PROD || process.env.REACT_APP_API_URL
    : process.env.REACT_APP_API_URL_LOCAL || process.env.REACT_APP_API_URL;
let isLoggingOut = false;

export const logoutAdmin = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('admin');

  if (!isLoggingOut && window.location.pathname !== '/login') {
    isLoggingOut = true;
    window.location.replace('/login');
  }
};

const api = axios.create({
  baseURL: API_URL,
});

// Add token to requests if it exists
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const requestUrl = error.config?.url || '';
    const token = localStorage.getItem('token');
    const isLoginRequest = requestUrl.includes('/auth/login');

    if ((status === 401 || status === 403) && token && !isLoginRequest) {
      logoutAdmin();
    }

    return Promise.reject(error);
  }
);

// Auth API calls
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
};

// Admin API calls
export const adminAPI = {
  getAll: (params) => api.get('/admins', { params }),
  create: (data) => api.post('/admins', data),
  update: (id, data) => api.put(`/admins/${id}`, data),
  delete: (id) => api.delete(`/admins/${id}`),
  restore: (id) => api.post(`/admins/${id}/restore`),
};

// Teacher API calls
export const teacherAPI = {
  getAll: (params) => api.get('/teachers', { params }),
  getById: (id) => api.get(`/teachers/${id}`),
  create: (data) => api.post('/teachers', data),
  update: (id, data) => api.put(`/teachers/${id}`, data),
  delete: (id) => api.delete(`/teachers/${id}`),
  restore: (id) => api.post(`/teachers/${id}/restore`),
};

// Class API calls
export const classAPI = {
  getAll: (params) => api.get('/classes', { params }),
  create: (data) => api.post('/classes', data),
  update: (id, data) => api.put(`/classes/${id}`, data),
};

export const feeCategoryAPI = {
  getAll: (params) => api.get('/fee-categories', { params }),
  create: (data) => api.post('/fee-categories', data),
  update: (id, data) => api.put(`/fee-categories/${id}`, data),
};

export const academicSessionAPI = {
  getAll: (params) => api.get('/academic-sessions', { params }),
  create: (data) => api.post('/academic-sessions', data),
  update: (id, data) => api.put(`/academic-sessions/${id}`, data),
};

export const siteEnquiryAPI = {
  getAll: (params) => api.get('/site-enquiries', { params }),
  create: (data) => api.post('/site-enquiries', data),
};

// Student API calls
export const studentAPI = {
  getAll: (params) => api.get('/students', { params }),
  getById: (id) => api.get(`/students/${id}`),
  create: (data) => api.post('/students', data),
  update: (id, data) => api.put(`/students/${id}`, data),
  delete: (id) => api.delete(`/students/${id}`),
  transfer: (id, data) => api.post(`/students/${id}/transfer`, data),
  getStatistics: () => api.get('/students/statistics/summary'),
  getUpcomingBirthdays: (params) => api.get('/students/upcoming-birthdays', { params }),
};

// Fee Payments API calls
export const feePaymentAPI = {
  getAll: (params) => api.get('/fee-payments', { params }),
  getSummary: (params) => api.get('/fee-payments/summary', { params }),
  export: (params) => api.get('/fee-payments/export', { params, responseType: 'blob' }),
  getById: (id) => api.get(`/fee-payments/${id}`),
  create: (data) => api.post('/fee-payments', data),
  update: (id, data) => api.put(`/fee-payments/${id}`, data),
  delete: (id) => api.delete(`/fee-payments/${id}`),
};

export default api;
